import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback, useMemo, useRef, useState } from "react";
import { Svg } from "react-native-svg";
import { Box, HStack, Text } from "native-base";
import { formatDateTime, isWeb } from "@madmedical/utils";
import { svgNative, svgWeb, thumbnailFooter, thumbnailGraphSlot, thumbnailHeader, thumbnailRoot, thumbnailUnit, thumbnailValue, thumbnailValueSlot, } from "./useStyles";
import { normalizeGraphProps } from "./utils";
import GraphBar from "./GraphBar";
import GraphColumn from "./GraphColumn";
import GraphDot from "./GraphDot";
import GraphLinePaired from "./GraphLinePaired";
import GraphLineSingle from "./GraphLineSingle";
export default function GraphTumbnail({ graphProps = {}, }) {
    // ##########################
    var _a, _b;
    const [slotX, setSlotX] = useState((_b = (_a = graphProps.slot) === null || _a === void 0 ? void 0 : _a.x) !== null && _b !== void 0 ? _b : 100);
    const graphData = useMemo(() => {
        var _a;
        const graphPropsMiddleware = Object.assign({}, graphProps);
        if (isWeb && ((_a = graphPropsMiddleware.slot) === null || _a === void 0 ? void 0 : _a.x))
            graphPropsMiddleware.slot.x = slotX;
        const normalizedGraphProps = normalizeGraphProps(graphPropsMiddleware);
        return Object.assign(Object.assign({}, normalizedGraphProps), { coords: normalizedGraphProps === null || normalizedGraphProps === void 0 ? void 0 : normalizedGraphProps.coordsAll });
    }, [graphProps, slotX]);
    // ##########################
    const { type, coords = [], slot = { x: 0, y: 0 }, unit, dashboardThumbnail: { title = "", valueToDisplay = "" } = {}, } = graphData !== null && graphData !== void 0 ? graphData : {};
    const lastMeasureMsec = useMemo(() => { var _a; return (_a = [...coords].reverse().find(({ yHigh }) => yHigh)) === null || _a === void 0 ? void 0 : _a.msec; }, [coords]);
    const viewBoxOriginY = isWeb ? 0 : 0 - slot.y;
    // ##########################
    const resizeObserver = useRef();
    const anchor = useCallback((div) => {
        var _a;
        if (isWeb) {
            if (!div)
                return;
            if (resizeObserver.current)
                resizeObserver.current.disconnect();
            resizeObserver.current = new ResizeObserver((entries) => setSlotX(entries[0].contentRect.width));
            resizeObserver.current.observe(div);
        }
        else {
            if (!((_a = div === null || div === void 0 ? void 0 : div.parentElement) === null || _a === void 0 ? void 0 : _a.parentElement))
                return;
            slot.x =
                div.parentElement.parentElement.getBoundingClientRect()
                    .width - 50;
        }
    }, [slot]);
    // ##########################
    return (_jsxs(Box, Object.assign({ ref: anchor, style: thumbnailRoot }, { children: [_jsx(Text, Object.assign({ style: thumbnailHeader, numberOfLines: 1 }, { children: title })), valueToDisplay && (_jsx(_Fragment, { children: _jsxs(HStack, Object.assign({ style: thumbnailValueSlot, space: 1 }, { children: [_jsx(Text, Object.assign({ numberOfLines: 1, style: thumbnailValue }, { children: valueToDisplay })), _jsx(Text, Object.assign({ style: thumbnailUnit }, { children: unit }))] })) })), _jsx(Box, Object.assign({ style: [
                    thumbnailGraphSlot,
                    {
                        width: slot.x,
                        height: slot.y,
                    },
                ] }, { children: _jsx(Svg
                // xmlns="http://www.w3.org/2000/svg"
                , Object.assign({ 
                    // xmlns="http://www.w3.org/2000/svg"
                    viewBox: `0 ${viewBoxOriginY - 2} ${slot.x} ${slot.y + 5}`, style: isWeb ? svgWeb : svgNative }, { children: type === "line-single" ? (_jsx(GraphLineSingle, { graphData: graphData })) : type === "line-paired" ? (_jsx(GraphLinePaired, { graphData: graphData })) : type === "column" ? (_jsx(GraphColumn, { graphData: graphData })) : type === "dot" ? (_jsx(GraphDot, { graphData: graphData })) : type === "bar" ? (_jsx(GraphBar, { graphData: graphData })) : (_jsx(_Fragment, {})) })) })), _jsx(Text, Object.assign({ style: thumbnailFooter }, { children: lastMeasureMsec ? formatDateTime(lastMeasureMsec) : "" }))] })));
}
